import helpers from '../helpers';
import utils from '../utils';

let $currentArticle = null;
let $articleMore = null;
let $articleMoreText = null;

const init = ($article) => {
	$currentArticle = $article;
	$articleMore = $currentArticle.find('.article__more');
	$articleMoreText = $currentArticle.find('.article__more-arc-text');

	const $articleMoreArc = $currentArticle.find('.article__more-arc-text textPath');
	const $articleMoreBtn = $currentArticle.find('.article__more-button');
	const $articleMoreLine = $currentArticle.find('.article__more-line-inner');

	const multiplier = innerWidth >= 2000 ? 2.3 : 2;

	if (helpers.isMobile()) {
		$articleMore.removeClass('visibility-hidden');
	} else {
		helpers.$window.on('scroll.moreArc', () => {
			if (
				utils.checkItemPos($articleMoreText, innerHeight / multiplier)
				&& !$articleMoreText.hasClass('is-animated')
			) {
				helpers.$window.off('.moreArc');

				$articleMoreText.addClass('is-animated');

				setTimeout(() => {
					$articleMore.removeClass('visibility-hidden');

					gsap.from($articleMore, {
						onStart: () => {
							const $currentArcText = $articleMoreArc.text();

							$articleMoreArc.html('');

							gsap.timeline()
								.to($articleMoreArc, {
									duration: 0.75,
									ease: 'none',
									text: $currentArcText,
								})
								.from($articleMoreBtn, {
									delay: 0.25,
									autoAlpha: 0,
								})
								.to($articleMoreLine, {
									height: '100%',
								});
						},
					});
				}, 300);
			}
		});
	}
};

const destroy = () => {
	helpers.$window.off('.moreArc');

	if ($currentArticle) {
		$articleMore.addClass('visibility-hidden');
		$articleMoreText.removeClass('is-animated');
		$currentArticle = null;
	}
};

export default {
	init,
	destroy,
};
